import React from "react";
import NewsComponent from "../HomePage/News";
import Style from '../Styles/Common.module.css';

const NewsPage = ()=>{
    return(
        <div className={Style.pageTitle + ' ' + Style.eventPage + ' ' + Style.pageShoeComp}>
            <NewsComponent />
        </div>
    )
}

export default NewsPage;